import React, { useState } from 'react';

const PasswordRecovery = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleRecovery = async () => {
    try {
      const response = await fetch('http://localhost:3001/recover-password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();
      if (response.ok) {
        setMessage('Instrucciones de recuperación enviadas a tu correo electrónico.');
      } else {
        setMessage(data.message);
      }
    } catch (error) {
      setMessage('Error al enviar la solicitud de recuperación.');
    }
  };

  return (
    <div>
      <h2>Recuperar Contraseña</h2>
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Ingresa tu correo electrónico"
      />
      <button onClick={handleRecovery}>Recuperar Contraseña</button>
      <div>{message}</div>
    </div>
  );
};

export default PasswordRecovery;
